import { Injectable } from '@angular/core'
import { adobeLaunch } from 'vg-fas-adobe-launch'

@Injectable({
  providedIn: 'root',
})
export class AdobeLaunchService {
  public readonly defaultCtaLocation = 'betr calculator'
  private taskCompletedThisSession: boolean = false;

  public static readonly pageDefaults = {
    platform: 'web',
    siteSection1: 'tax-center',
    siteSection2: 'tools',
    siteIdentifier: 'fas',
    pageTemplate: 'Roth BETR Calculator',
    subPage1: 'roth-betr-calculator',
    subPage2: 'version3',
  }

  public static readonly chartIds = {
    assetgrowthChartId: 'asset growth',
    breakevenChartId: 'break-even point',
  }

  public static readonly errorCodes = {
    rangeError: 'betrnotdefinedrange',
    dividendGreaterThanAnnualError: 'betrdividendgreaterthanannualreturn',
  }

  private ctaHistory: string[] = []
  private chartHistory: string[] = [
    AdobeLaunchService.chartIds.breakevenChartId + 'N',
  ]

  public initializePage(pageData: any, toolData: any): void {
    adobeLaunch.initializePage(pageData)
    adobeLaunch.trackEvent('toolUsed', 'tool', toolData)
  }

  public captureAction(
    name: string,
    type: string,
    location: string = this.defaultCtaLocation,
  ): void {
    if (name === 'task complete') {
      if (this.taskCompletedThisSession) return;
      this.taskCompletedThisSession = true;
    }
    adobeLaunch.trackEvent('callToAction', 'callToAction', { location, ctaName: name, ctaType: type })
  }

  public captureCtaButton(
    name: string,
    location: string = this.defaultCtaLocation,
  ): void {
    this.captureAction(name, 'button', location)
  }

  public captureCtaLink(
    name: string,
    location: string = this.defaultCtaLocation,
  ): void {
    this.captureAction(name, 'link', location)
  }

  public downloadAction(pdfName: string): void {
    adobeLaunch.trackContentDownloaded('pdf:' + pdfName)
  }

  public tagDownloadPDF(pdfLink: string) {
    const regexMatch = pdfLink.match('(?!\\/)[A-Za-z0-9]+(?=\\.pdf)');
    const pdfName = regexMatch ? regexMatch[0] : '';
    this.downloadAction(pdfName);
  }

  public subPageViewed(pageId: string, action: 'Y' | 'N' = 'Y'): void {
    adobeLaunch.trackSubpageViewed(pageId, action)
  }

  public pageLoadCompleted(): void {
    adobeLaunch.trackEvent('pageLoadCompleted', 'page')
  }

  public toolUsed(): void {
    adobeLaunch.trackEvent('toolUsed', 'tool', {
      toolName: 'BETR Calculator',
      toolCategory: 'calculator',
    })
  }

  public trackError(errorCode: string, step: string): void {
    adobeLaunch.trackEvent('processError', 'process', {
      errorCode: errorCode,
      processType: 'betrinputvalues',
      processStep: step,
      processSideStep: null,
    })
  }
}
